import React, { useState, useEffect } from 'react';

interface HeroProps {
  onNavigate: (path: string) => void;
  onSignIn: () => void;
  onSignUp: () => void;
  onPurchase?: (productId: string, productName: string) => void;
}

// WFT Module data met Stripe product IDs
const WFT_MODULES = [
  { id: 'schade-particulier', name: 'Schade Particulier', productId: 'exam_single', available: true },
  { id: 'schade-zakelijk', name: 'Schade Zakelijk', productId: 'exam_single', available: true },
  { id: 'basis', name: 'Basis', productId: 'exam_single', available: true },
  { id: 'hypotheken', name: 'Hypotheken', productId: 'exam_single', available: true },
  { id: 'pensioen', name: 'Pensioen', productId: 'exam_single', available: true },
  { id: 'vermogen', name: 'Vermogen', productId: 'exam_single', available: true },
  { id: 'inkomen', name: 'Inkomen', productId: 'exam_single', available: true },
  { id: 'consumptief-krediet', name: 'Consumptief Krediet', productId: 'exam_single', available: true },
  { id: 'zorg', name: 'Zorg', productId: 'exam_single', available: true },
];

// Minimale monochrome SVG iconen
const ModuleIcon: React.FC<{ moduleId: string; className?: string }> = ({ moduleId, className = "w-6 h-6" }) => {
  const icons: Record<string, React.ReactElement> = {
    'schade-particulier': (
      <svg className={className} fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth={1.5}>
        <path strokeLinecap="round" strokeLinejoin="round" d="M2.25 12l8.954-8.955c.44-.439 1.152-.439 1.591 0L21.75 12M4.5 9.75v10.125c0 .621.504 1.125 1.125 1.125H9.75v-4.875c0-.621.504-1.125 1.125-1.125h2.25c.621 0 1.125.504 1.125 1.125V21h4.125c.621 0 1.125-.504 1.125-1.125V9.75M8.25 21h8.25" />
      </svg>
    ),
    'schade-zakelijk': (
      <svg className={className} fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth={1.5}>
        <path strokeLinecap="round" strokeLinejoin="round" d="M3.75 21h16.5M4.5 3h15M5.25 3v18m13.5-18v18M9 6.75h1.5m-1.5 3h1.5m-1.5 3h1.5m3-6H15m-1.5 3H15m-1.5 3H15M9 21v-3.375c0-.621.504-1.125 1.125-1.125h3.75c.621 0 1.125.504 1.125 1.125V21" />
      </svg>
    ),
    'basis': (
      <svg className={className} fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth={1.5}>
        <path strokeLinecap="round" strokeLinejoin="round" d="M12 6.042A8.967 8.967 0 006 3.75c-1.052 0-2.062.18-3 .512v14.25A8.987 8.987 0 016 18c2.305 0 4.408.867 6 2.292m0-14.25a8.966 8.966 0 016-2.292c1.052 0 2.062.18 3 .512v14.25A8.987 8.987 0 0018 18a8.967 8.967 0 00-6 2.292m0-14.25v14.25" />
      </svg>
    ),
    'hypotheken': (
      <svg className={className} fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth={1.5}>
        <path strokeLinecap="round" strokeLinejoin="round" d="M8.25 21v-4.875c0-.621.504-1.125 1.125-1.125h2.25c.621 0 1.125.504 1.125 1.125V21m0 0h4.5V3.545M12.75 21h7.5V10.75M2.25 21h1.5m18 0h-18M2.25 9l4.5-1.636M18.75 3l-1.5.545m0 6.205l3 1m1.5.5l-1.5-.5M6.75 7.364V3h-3v18m3-13.636l10.5-3.819" />
      </svg>
    ),
    'pensioen': (
      <svg className={className} fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth={1.5}>
        <path strokeLinecap="round" strokeLinejoin="round" d="M12 6v6h4.5m4.5 0a9 9 0 11-18 0 9 9 0 0118 0z" />
      </svg>
    ),
    'vermogen': (
      <svg className={className} fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth={1.5}>
        <path strokeLinecap="round" strokeLinejoin="round" d="M2.25 18.75a60.07 60.07 0 0115.797 2.101c.727.198 1.453-.342 1.453-1.096V18.75M3.75 4.5v.75A.75.75 0 013 6h-.75m0 0v-.375c0-.621.504-1.125 1.125-1.125H20.25M2.25 6v9m18-10.5v.75c0 .414.336.75.75.75h.75m-1.5-1.5h.375c.621 0 1.125.504 1.125 1.125v9.75c0 .621-.504 1.125-1.125 1.125h-.375m1.5-1.5H21a.75.75 0 00-.75.75v.75m0 0H3.75m0 0h-.375a1.125 1.125 0 01-1.125-1.125V15m1.5 1.5v-.75A.75.75 0 003 15h-.75M15 10.5a3 3 0 11-6 0 3 3 0 016 0zm3 0h.008v.008H18V10.5zm-12 0h.008v.008H6V10.5z" />
      </svg>
    ),
    'inkomen': (
      <svg className={className} fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth={1.5}>
        <path strokeLinecap="round" strokeLinejoin="round" d="M20.25 14.15v4.25c0 1.094-.787 2.036-1.872 2.18-2.087.277-4.216.42-6.378.42s-4.291-.143-6.378-.42c-1.085-.144-1.872-1.086-1.872-2.18v-4.25m16.5 0a2.18 2.18 0 00.75-1.661V8.706c0-1.081-.768-2.015-1.837-2.175a48.114 48.114 0 00-3.413-.387m4.5 8.006c-.194.165-.42.295-.673.38A23.978 23.978 0 0112 15.75c-2.648 0-5.195-.429-7.577-1.22a2.016 2.016 0 01-.673-.38m0 0A2.18 2.18 0 013 12.489V8.706c0-1.081.768-2.015 1.837-2.175a48.111 48.111 0 013.413-.387m7.5 0V5.25A2.25 2.25 0 0013.5 3h-3a2.25 2.25 0 00-2.25 2.25v.894m7.5 0a48.667 48.667 0 00-7.5 0M12 12.75h.008v.008H12v-.008z" />
      </svg>
    ),
    'consumptief-krediet': (
      <svg className={className} fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth={1.5}>
        <path strokeLinecap="round" strokeLinejoin="round" d="M2.25 8.25h19.5M2.25 9h19.5m-16.5 5.25h6m-6 2.25h3m-3.75 3h15a2.25 2.25 0 002.25-2.25V6.75A2.25 2.25 0 0019.5 4.5h-15a2.25 2.25 0 00-2.25 2.25v10.5A2.25 2.25 0 004.5 19.5z" />
      </svg>
    ),
    'zorg': (
      <svg className={className} fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth={1.5}>
        <path strokeLinecap="round" strokeLinejoin="round" d="M21 8.25c0-2.485-2.099-4.5-4.688-4.5-1.935 0-3.597 1.126-4.312 2.733-.715-1.607-2.377-2.733-4.313-2.733C5.1 3.75 3 5.765 3 8.25c0 7.22 9 12 9 12s9-4.78 9-12z" />
      </svg>
    ),
  };

  return icons[moduleId] || icons['basis'];
};

const Hero: React.FC<HeroProps> = ({ onNavigate, onSignIn, onSignUp, onPurchase }) => {
  const [scrolled, setScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    document.body.style.overflow = isMobileMenuOpen ? 'hidden' : 'unset';
    return () => { document.body.style.overflow = 'unset'; };
  }, [isMobileMenuOpen]);

  const scrollToSection = (sectionId: string) => {
    document.getElementById(sectionId)?.scrollIntoView({ behavior: 'smooth' });
    setIsMobileMenuOpen(false);
  };

  const handleModulePurchase = (module: typeof WFT_MODULES[0]) => {
    if (!module.available) return;
    
    // Trigger purchase flow met product info
    if (onPurchase) {
      onPurchase('exam_single', `Proefexamen ${module.name}`);
    }
  };

  const handleProPurchase = () => {
    if (onPurchase) {
      onPurchase('pro_monthly', 'Pro Abonnement Maandelijks');
    }
  };

  return (
    <>
      {/* Navigation Header */}
      <nav className={`fixed top-0 w-full z-50 transition-all duration-300 ${
        scrolled ? 'bg-white shadow-lg py-4' : 'bg-transparent py-6'
      }`}>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center">
            {/* Logo */}
            <div className="flex items-center space-x-2">
              <div className="w-10 h-10 bg-gradient-to-br from-blue-500 to-purple-600 rounded-lg flex items-center justify-center">
                <span className="text-white font-bold text-xl">W</span>
              </div>
              <span className="text-2xl font-bold bg-gradient-to-r from-blue-600 to-purple-600 bg-clip-text text-transparent">
                WFT Study Buddy
              </span>
            </div>

            {/* Desktop Navigation */}
            <div className="hidden md:flex items-center space-x-8">
              <a href="#features" onClick={(e) => { e.preventDefault(); scrollToSection('features'); }} className="text-gray-600 hover:text-blue-600 transition">Features</a>
              <a href="#how-it-works" onClick={(e) => { e.preventDefault(); scrollToSection('how-it-works'); }} className="text-gray-600 hover:text-blue-600 transition">Hoe werkt het?</a>
              <a href="#pricing" onClick={(e) => { e.preventDefault(); scrollToSection('pricing'); }} className="text-gray-600 hover:text-blue-600 transition">Prijzen</a>
              <a href="/informatie" onClick={(e) => { e.preventDefault(); onNavigate('/informatie'); }} className="text-gray-600 hover:text-blue-600 transition">Informatie</a>
              <button onClick={onSignIn} className="text-gray-600 hover:text-blue-600 transition">Inloggen</button>
              <button onClick={onSignUp} className="bg-gradient-to-r from-blue-600 to-purple-600 text-white px-6 py-2 rounded-lg hover:shadow-lg transform hover:scale-105 transition">
                Registreren
              </button>
            </div>

            {/* Mobile Menu Button */}
            <button
              onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
              className="md:hidden text-gray-600 hover:text-blue-600 transition-colors z-50"
              aria-label={isMobileMenuOpen ? "Menu sluiten" : "Menu openen"}
            >
              <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                {isMobileMenuOpen ? (
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                ) : (
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
                )}
              </svg>
            </button>
          </div>
        </div>
      </nav>

      {/* Mobile Menu Overlay */}
      {isMobileMenuOpen && (
        <div className="fixed inset-0 bg-black/50 z-40 md:hidden" onClick={() => setIsMobileMenuOpen(false)} />
      )}

      {/* Mobile Menu Panel */}
      <div className={`fixed top-0 right-0 h-full w-80 bg-white shadow-2xl z-40 md:hidden transform transition-transform duration-300 ${
        isMobileMenuOpen ? 'translate-x-0' : 'translate-x-full'
      }`}>
        <div className="flex flex-col h-full pt-20 px-6">
          <nav className="flex flex-col space-y-4">
            <a href="#features" onClick={() => scrollToSection('features')} className="text-lg text-gray-700 hover:text-blue-600 py-2 border-b border-gray-100">Features</a>
            <a href="#how-it-works" onClick={() => scrollToSection('how-it-works')} className="text-lg text-gray-700 hover:text-blue-600 py-2 border-b border-gray-100">Hoe werkt het?</a>
            <a href="#pricing" onClick={() => scrollToSection('pricing')} className="text-lg text-gray-700 hover:text-blue-600 py-2 border-b border-gray-100">Prijzen</a>
           <a href="/informatie" onClick={(e) => { e.preventDefault(); onNavigate('/informatie'); setIsMobileMenuOpen(false); }} className="text-lg text-gray-700 hover:text-blue-600 py-2 border-b border-gray-100">Informatie</a>
            <div className="pt-4 space-y-3">
              <button onClick={() => { onSignIn(); setIsMobileMenuOpen(false); }} className="w-full py-3 border border-gray-300 rounded-lg font-medium text-gray-700 hover:bg-gray-50">Inloggen</button>
              <button onClick={() => { onSignUp(); setIsMobileMenuOpen(false); }} className="w-full py-3 bg-gradient-to-r from-blue-600 to-purple-600 text-white rounded-lg font-medium">Registreren</button>
            </div>
          </nav>
        </div>
      </div>

      {/* Hero Section */}
      <section className="relative min-h-screen flex items-center bg-gradient-to-br from-slate-50 via-blue-50 to-indigo-50 overflow-hidden pt-20">
        {/* Background decorations */}
        <div className="absolute inset-0 overflow-hidden">
          <div className="absolute -top-40 -right-40 w-80 h-80 bg-blue-200 rounded-full mix-blend-multiply filter blur-xl opacity-50"></div>
          <div className="absolute -bottom-40 -left-40 w-80 h-80 bg-indigo-200 rounded-full mix-blend-multiply filter blur-xl opacity-50"></div>
        </div>

        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            
            {/* Left Column - Text */}
            <div className="space-y-8 text-center lg:text-left">
              <div className="inline-flex items-center space-x-2 bg-white/80 backdrop-blur-sm px-4 py-2 rounded-full shadow-sm border border-gray-100">
                <span className="w-2 h-2 bg-green-500 rounded-full"></span>
                <span className="text-sm font-medium text-gray-700">500+ studenten gingen je voor</span>
              </div>

              <h1 className="text-4xl sm:text-5xl lg:text-6xl font-extrabold leading-tight text-gray-900">
                Haal je{' '}
                <span className="bg-gradient-to-r from-blue-600 to-indigo-600 bg-clip-text text-transparent">
                  WFT examen
                </span>
                {' '}in één keer
              </h1>

              <p className="text-lg sm:text-xl text-gray-600 leading-relaxed max-w-xl">
                Bereid je voor met realistische proefexamens, AI-gegenereerde oefenvragen en complete samenvattingen per module.
              </p>

              <div className="flex flex-col sm:flex-row gap-4 justify-center lg:justify-start">
                <button 
                  onClick={onSignUp}
                  className="group bg-gradient-to-r from-blue-600 to-indigo-600 text-white px-8 py-4 rounded-xl font-semibold text-lg shadow-lg hover:shadow-xl transform hover:scale-[1.02] transition-all flex items-center justify-center gap-2"
                >
                  <span>Maak gratis account</span>
                  <svg className="w-5 h-5 group-hover:translate-x-1 transition-transform" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 7l5 5m0 0l-5 5m5-5H6" />
                  </svg>
                </button>
                <button 
                  onClick={() => scrollToSection('pricing')}
                  className="hidden sm:flex items-center justify-center gap-2 px-8 py-4 rounded-xl font-semibold text-gray-700 border-2 border-gray-200 hover:border-blue-300 hover:bg-white transition-all"
                >
                  Bekijk prijzen
                </button>
              </div>

              {/* Trust indicators */}
              <div className="flex items-center justify-center lg:justify-start gap-6 pt-4">
                <div className="flex items-center gap-2 text-sm text-gray-600">
                  <svg className="w-5 h-5 text-green-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                  </svg>
                  <span>Officiële toetstermen</span>
                </div>
                <div className="flex items-center gap-2 text-sm text-gray-600">
                  <svg className="w-5 h-5 text-green-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                  </svg>
                  <span>iDEAL betaling</span>
                </div>
              </div>
            </div>

            {/* Right Column - Module Selector */}
            <div className="relative">
              <div className="bg-white rounded-2xl shadow-xl border border-gray-100 overflow-hidden">
                {/* Header */}
                <div className="bg-gradient-to-r from-gray-50 to-gray-100 px-6 py-4 border-b border-gray-100">
                  <h2 className="text-lg font-semibold text-gray-900">Kies je WFT module</h2>
                  <p className="text-sm text-gray-500">Per proefexamen €4,99 of onbeperkt met Pro</p>
                </div>

                {/* Module Grid */}
                <div className="p-4">
                  <div className="grid grid-cols-3 gap-2">
                    {WFT_MODULES.map((module) => (
                      <button
                        key={module.id}
                        onClick={() => handleModulePurchase(module)}
                        disabled={!module.available}
                        className={`
                          relative p-3 rounded-xl text-center transition-all duration-200 group
                          ${module.available 
                            ? 'bg-gray-50 hover:bg-blue-50 hover:border-blue-200 border border-transparent cursor-pointer' 
                            : 'bg-gray-100 opacity-50 cursor-not-allowed'
                          }
                        `}
                      >
                        <div className="text-gray-400 group-hover:text-blue-600 transition-colors flex justify-center mb-1">
                          <ModuleIcon moduleId={module.id} className="w-6 h-6" />
                        </div>
                        <span className="text-xs font-medium text-gray-700 group-hover:text-gray-900 block leading-tight">
                          {module.name}
                        </span>
                        {!module.available && (
                          <span className="absolute top-1 right-1 text-[8px] bg-gray-200 text-gray-500 px-1.5 py-0.5 rounded-full">
                            Binnenkort
                          </span>
                        )}
                      </button>
                    ))}
                  </div>
                </div>

                {/* Pricing Summary */}
                <div className="px-4 pb-4">
                  <div className="bg-gray-50 rounded-xl p-4 space-y-3">
                    <div className="flex items-center justify-between text-sm">
                      <span className="text-gray-600">Per proefexamen</span>
                      <span className="font-semibold text-gray-900">€4,99</span>
                    </div>
                    <div className="flex items-center justify-between text-sm">
                      <span className="text-gray-600">Per samenvatting</span>
                      <span className="font-semibold text-gray-900">€4,99</span>
                    </div>
                    <div className="border-t border-gray-200 pt-3">
                      <div className="flex items-center justify-between">
                        <div>
                          <span className="text-sm font-semibold text-indigo-700">Pro Abonnement</span>
                          <p className="text-xs text-gray-500">Alles onbeperkt toegang</p>
                        </div>
                        <span className="font-bold text-indigo-700">€19,99<span className="text-xs font-normal text-gray-500">/mnd</span></span>
                      </div>
                    </div>
                  </div>
                </div>

                {/* CTA Button */}
                <div className="px-4 pb-4">
                  <button 
                    onClick={handleProPurchase}
                    className="w-full bg-gradient-to-r from-indigo-600 to-purple-600 text-white py-3.5 rounded-xl font-semibold shadow-lg hover:shadow-xl transform hover:scale-[1.01] transition-all"
                  >
                    Bekijk Pro Abonnement
                  </button>
                </div>

                {/* Footer trust badges */}
                <div className="px-4 pb-4">
                  <div className="flex items-center justify-center gap-4 text-xs text-gray-400">
                    <span className="flex items-center gap-1">
                      <svg className="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
                      </svg>
                      Veilig betalen
                    </span>
                    <span className="flex items-center gap-1">
                      <svg className="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                      </svg>
                      Direct toegang
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Hero;